import { BAR_CHART_LINE_HEIGHTS } from "@utils/settings/index.js";

export const getTimelineBarWeight = (value) => {
  const i = BAR_CHART_LINE_HEIGHTS.BOUNDARIES.findIndex(b => value <= b);
  let w = 1;
  if(i >= 0) {
    w = BAR_CHART_LINE_HEIGHTS.WEIGHTS[i]
  }
  return w;
}